function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay');
var AuthTemplate = require('./auth.template');
var AUTH_STATUS = {
  SUCCESS: 'success',
  CANCELLED: 'cancelled',
  ERROR: 'error',
  REJECTED: 'rejected'
};

/**
 * Identity-acquisition overlay (module-local until a second consumer exists).
 *
 * Acquires an abstract identity via a configured provider list.
 * Does not evaluate eligibility, issue tokens, or enforce onboarding policy —
 * callers own those decisions after receiving the result.
 *
 * Callback result:
 *   {
 *     status: 'success' | 'cancelled' | 'error' | 'rejected',
 *     provider: string | null,
 *     identity: {
 *       provider, provider_id, username, display_name, email, avatar, metadata
 *     } | null,
 *     error: string | null
 *   }
 */
var Auth = /*#__PURE__*/function () {
  function Auth(app, mod) {
    var _app$browser;
    _classCallCheck(this, Auth);
    this.app = app;
    this.mod = mod;
    if (app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && _app$browser.addStylesheet) {
      app.browser.addStylesheet('/faucet/style.css');
    }
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.callback = null;
    this.title = '';
    this.message = '';
    this.activeProviders = [];

    /** Full registry — filter via render({ providers: [...] }). */
    this.providers = [{
      id: 'github',
      name: 'GitHub',
      icon: 'fa-brands fa-github'
    }, {
      id: 'twitter',
      name: 'X',
      icon: 'fa-brands fa-x-twitter'
    }];
  }

  /**
   * Show the auth overlay.
   *
   * @param {object|function} [options]
   * @param {string} [options.title]
   * @param {string} [options.message] Plain text; blank lines become separate paragraphs
   * @param {string[]} [options.providers] Provider ids to show (subset of registry)
   * @param {function} [options.callback]
   */
  return _createClass(Auth, [{
    key: "render",
    value: function render() {
      var _this = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Back-compat: render(callback)
      if (typeof options === 'function') {
        options = {
          callback: options
        };
      }
      var opts = options && _typeof(options) === 'object' ? options : {};
      this.title = String(opts.title || 'Welcome to Saito').trim() || 'Welcome to Saito';
      this.message = String(opts.message || "To continue, please verify one of your existing online accounts.\n\nWe never post on your behalf.");
      this.callback = typeof opts.callback === 'function' ? opts.callback : null;
      this.activeProviders = this.resolveProviders(opts.providers);
      this.overlay.show(AuthTemplate({
        title: this.title,
        message: this.message,
        providers: this.activeProviders
      }), function () {
        _this.finish({
          status: AUTH_STATUS.CANCELLED,
          provider: null,
          identity: null,
          error: null
        });
      });
      this.attachEvents();
    }
  }, {
    key: "resolveProviders",
    value: function resolveProviders(requested) {
      var _this2 = this;
      var ids = Array.isArray(requested) && requested.length ? requested.map(function (id) {
        return String(id || '').trim();
      }).filter(Boolean) : this.providers.map(function (p) {
        return p.id;
      });
      var resolved = [];
      var _iterator = _createForOfIteratorHelper(ids),
        _step;
      try {
        var _loop = function _loop() {
          var id = _step.value;
          var provider = _this2.providers.find(function (p) {
            return p.id === id;
          });
          if (provider) {
            resolved.push(provider);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return resolved.length ? resolved : _toConsumableArray(this.providers);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var root = document.querySelector('.auth');
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-auth-provider]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          var id = btn.getAttribute('data-auth-provider');
          var provider = _this3.activeProviders.find(function (p) {
            return p.id === id;
          });
          if (provider) {
            _this3.authenticate(provider);
          }
        };
      });
      var cancelBtn = root.querySelector('[data-auth-cancel]');
      if (cancelBtn) {
        cancelBtn.onclick = function (e) {
          e.preventDefault();
          _this3.cancel();
        };
      }
    }

    /**
     * Begin provider authentication.
     * GitHub and X open a Faucet-owned OAuth initiation popup (does not navigate Saito).
     * @param {{ id: string, name?: string, icon?: string }} provider
     */
  }, {
    key: "authenticate",
    value: function authenticate(provider) {
      if (!(provider !== null && provider !== void 0 && provider.id)) {
        this.finish({
          status: AUTH_STATUS.ERROR,
          provider: null,
          identity: null,
          error: 'Unknown authentication provider'
        });
        this.overlay.close();
        return;
      }
      if (provider.id === 'github' || provider.id === 'twitter') {
        var _this$mod, _this$mod2;
        if (typeof window === 'undefined' || typeof window.open !== 'function') {
          this.finish({
            status: AUTH_STATUS.ERROR,
            provider: provider.id,
            identity: null,
            error: 'Browser cannot open an OAuth window'
          });
          return;
        }
        var slug = typeof ((_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.returnSlug) === 'function' ? this.mod.returnSlug() : 'faucet';
        var oauthUrl = new URL("/".concat(encodeURI(slug), "/oauth/").concat(encodeURI(provider.id)), window.location.origin);
        var publickey = String(((_this$mod2 = this.mod) === null || _this$mod2 === void 0 ? void 0 : _this$mod2.publicKey) || '').trim();
        if (publickey) {
          oauthUrl.searchParams.set('publickey', publickey);
        }
        var popup = window.open(oauthUrl.toString(), 'saito_faucet_oauth_' + provider.id, 'popup=yes,width=560,height=720,menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes');
        if (!popup) {
          siteMessage('Please allow popups to continue with ' + (provider.name || provider.id) + ' authentication.', 4000);
        }
        return;
      }
      siteMessage('That authentication provider is not available yet.', 3000);
    }

    /**
     * Close without treating it as user cancel (null callback first).
     */
  }, {
    key: "close",
    value: function close() {
      this.callback = null;
      if (this.overlay) {
        this.overlay.close();
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.finish({
        status: AUTH_STATUS.CANCELLED,
        provider: null,
        identity: null,
        error: null
      });
      this.overlay.close();
    }

    /**
     * Invoke the caller callback once. Nulls the callback before close so the
     * overlay dismiss hook does not double-fire (Create NFT pattern).
     */
  }, {
    key: "finish",
    value: function finish(result) {
      var _result$provider, _result$identity, _result$error;
      if (typeof this.callback !== 'function') {
        return;
      }
      var cb = this.callback;
      this.callback = null;
      cb({
        status: result.status || AUTH_STATUS.ERROR,
        provider: (_result$provider = result.provider) !== null && _result$provider !== void 0 ? _result$provider : null,
        identity: (_result$identity = result.identity) !== null && _result$identity !== void 0 ? _result$identity : null,
        error: (_result$error = result.error) !== null && _result$error !== void 0 ? _result$error : null
      });
    }
  }]);
}();
Auth.STATUS = AUTH_STATUS;
module.exports = Auth;